const body = document.body;

export function NoScrollToggle() {
  body.classList.toggle("noscrolls");
}
